export default __webpack_public_path__ + "static/media/480_dummy2016-cafe01-mobile-de.77a8ab7b.png";